export default "__VITE_ASSET__CXwn29wf__"